import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Button, Form, Input, Modal, Spin} from "antd";
import {finishRegistrationProcess, clearStartRegistrationProcessInfo} from "../../../../store/notary-registration/actions";
import {api} from "../../../../utils/api";
import {InitSession} from "../../../../utils/SessionTracker";
import {routePath} from "../../../../router/paths";
import {BigLoading} from "../../../../components/BigLoading";
import {LoadingOutlined} from "@ant-design/icons";
import moment from "moment/moment";

const CheckDsModal = (props) => {
  const dispatch = useDispatch();
  const startRegistrationState = useSelector((state) => state.notaryRegistration.startRegistration);
  const finishRegistrationState = useSelector((state) => state.notaryRegistration.finishRegistration);
  const [registrationInfo, setRegistrationInfo] = useState(1)
  const onFinish = (data) => {

    if(data){
      for (const property in data) {
        if (typeof data[property] === "string"){
          data[property] = data[property].trim();
        }
      }

      data.clientId = startRegistrationState?.payload?.data?.clientId;
      data.signatureId = startRegistrationState?.payload?.data?.signatureId;
      delete data.phone;
      delete data.isNotary;
    }

    console.log('Success:', data);
    // props.setIsModalOpen(false)
    dispatch(finishRegistrationProcess(data))
  };

  useEffect(()=>{
    return ()=>{
      setRegistrationInfo(1)
    }
  },[])

  useEffect(() => {
    if (finishRegistrationState?.payload?.data?.status === "IDM-00") {
      setRegistrationInfo(2)
    }

    if (finishRegistrationState?.payload?.data?.status === "IDM-22") {
      setRegistrationInfo(3)
    }

  },[finishRegistrationState])


  const refreshTokenAndRedirect = ()=>{
    api.refreshToken().then(() => {
      props.history.push({
        pathname: routePath.NEW_REQUEST,
        state: {backPath: props.history.location.pathname}
      })
    })
  }

  return (
  <Modal
    // className="signing_modal"
    // title="Підписання запиту"
    closable={false}
    width={"45%"}
    // maskClosable={false}
    visible={props.visible}
    // onCancel={props.hideUploadModal}
    footer={false}
  >

    <div className="container">
      { registrationInfo === 1 &&
        startRegistrationState?.payload?.data?.isValid &&
        startRegistrationState?.payload?.data?.certificateNumber &&
        <div>
          <Form
            onFinish={onFinish}
            // onFinishFailed={onFinishFailed}
            autoComplete="off"
          >
            <Form.Item
              label="Ім’я користувача"
              name="firstName"
              initialValue={startRegistrationState?.payload?.data?.firstName}
              rules={[
                {required: true, message: 'обов\'язкове поле'},
                {
                  pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                  message: "наявність заборонених символів /\?%*:$#|<>«»",
                }
              ]}
            >
              <Input/>
            </Form.Item>

            <Form.Item
              label="По-батькові користувача"
              name="middleName"
              initialValue={startRegistrationState?.payload?.data?.middleName}
              rules={[
                // {required: true, message: 'обов\'язкове поле'},
                {
                  pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                  message: "наявність заборонених символів /\?%*:$#|<>«»",
                }
              ]}
            >
              <Input/>
            </Form.Item>

            <Form.Item
              label="Прізвище користувача"
              name="lastName"
              initialValue={startRegistrationState?.payload?.data?.lastName}
              rules={[
                {required: true, message: 'обов\'язкове поле'},
                {
                  pattern: /^[^<>«»#:$%"\/\\|?*\x00-\x1F]*$/,
                  message: "наявність заборонених символів /\?%*:$#|<>«»",
                }
              ]}
            >
              <Input/>
            </Form.Item>


            <Form.Item
              label="Номер телефона"
              name="phone"
              initialValue={startRegistrationState?.payload?.data?.phone}
              // rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label="Ознака нотаріуса"
              name="isNotary"
              initialValue={startRegistrationState?.payload?.data?.isNotary ? "Так":"Ні"}
              // rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label="Номер нотаріального свідоцтва"
              name="certificateNumber"
              initialValue={startRegistrationState?.payload?.data?.certificateNumber}
              // rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input disabled={true}/>
            </Form.Item>

            <Form.Item
              label="Дата завершення дії КЕП"
              name="certificateEndDate"
              style={{marginBottom: "2rem"}}
              initialValue={startRegistrationState?.payload?.data?.certificateEndDate}
              // rules={[{ required: true, message: 'Please input your username!' }]}
            >
              <Input disabled={true}/>
            </Form.Item>
            {/*moment("2023-08-31T12:01:38").format("YYYY-MM-DD")*/}
            <Form.Item wrapperCol={{offset: 8, span: 16}}>
              <Button
                type="primary"
                htmlType="submit"
                className="datas-btn datas-btn-small datas-btn-green"
              >
                {finishRegistrationState.isFetching ? <LoadingOutlined/> : "Ок" }
              </Button>
            </Form.Item>
          </Form>
        </div>
      }
      {<div>
        {registrationInfo === 1 && (!(startRegistrationState?.payload?.data?.isValid) || !(startRegistrationState?.payload?.data?.certificateNumber))  && !startRegistrationState?.error &&
        <>
          <div style={{marginBottom: "0.5rem"}}>
            <h2 style={{textAlign: "center"}}>Даний ключ КЕП не валідний або не є КЕП Нотаріуса</h2>
            <h2 style={{textAlign: "center"}}>Прохання повторити реєстрацію, використовуючи КЕП Нотаріуса</h2>
          </div>

          <div style={{display: "flex", justifyContent: "space-evenly"}}>
            <Button
              className="datas-btn datas-btn-small datas-btn-green"
              style={{marginRight: "0.5rem"}}
              onClick={() => {
                props.setRegFormVisible(false)
                props.setPrimaryMessageVisibility(true)
                props.setIsModalOpen(false)
                dispatch(clearStartRegistrationProcessInfo())
              }}
            >
              Ok
            </Button>
            <Button
              className="datas-btn datas-btn-small datas-btn-red"
              onClick={()=>{
                props.history.push({
                  pathname: routePath.DIGITAL_FRONT,
                  state: {backPath: props.history.location.pathname}
                })
              }}
            >
              Відмовитись
            </Button>
          </div>
        </>
        }
        {startRegistrationState?.error &&
          <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <h3 style={{textAlign: "center", marginTop:"2rem"}}><span
              style={{fontWeight: 500}}>ПОМИЛКА:  </span>{startRegistrationState?.error}</h3>
            <Button
              className="datas-btn datas-btn-small datas-btn-green"
              onClick={() => props.setIsModalOpen(false)}
              style={{marginLeft: "35%", marginTop: "2rem"}}
            >
              Повернутись
            </Button>
          </div>}

        {registrationInfo === 3 &&
          <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <h3 style={{textAlign: "center"}}><span
              style={{fontWeight: 500}}>ПОМИЛКА:  </span>{finishRegistrationState?.payload?.data?.description}</h3>
            <Button
              className="datas-btn datas-btn-small datas-btn-green"
              onClick={() => {
                setRegistrationInfo(1)
                props.setIsModalOpen(false)
              }}
              style={{marginLeft: "35%", marginTop: "2rem"}}
            >
              Повернутись
            </Button>
          </div>}

        {registrationInfo === 2 &&
          <div style={{display: "flex", flexDirection: "column", justifyContent: "center"}}>
            <h3 style={{textAlign: "center"}}><span
              style={{fontWeight: 500}}>Вас успішно зареєстровано</span></h3>
            <Button
              className="datas-btn datas-btn-small datas-btn-green"
              onClick={() => refreshTokenAndRedirect()}
              style={{marginLeft: "35%", marginTop: "2rem"}}
            >
              Ок
            </Button>
          </div>}
      </div>}
    </div>

  </Modal>
  );
};

export default CheckDsModal;